module.exports = __webpack_public_path__ + "HRA Brochure - First Dollar.pdf";